import "../footer.css";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="footer-logo">StudyForge</span>
            <p className="footer-tagline">
              Intelligent study planning for every learner.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-col">
              <span className="footer-col-title">Tool</span>
              <a href="#planner" className="footer-link">
                Study Planner
              </a>
              <a href="#tips" className="footer-link">
                Study Tips
              </a>
            </div>
            <div className="footer-col">
              <span className="footer-col-title">Info</span>
              <a href="#about" className="footer-link">
                About
              </a>
              <a href="#privacy" className="footer-link">
                Privacy
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-copy">
            © {year} StudyForge. All rights reserved.
          </span>
          <span className="footer-made">Made for students, by students.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
